module.exports = __webpack_public_path__ + "static/media/The-Pansodan.fe79a15f.png";